import styled from "styled-components";
import { InputText } from "@loanbossinc/component-library";

export const StyledTitle = styled.div`
&& {
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
`;

export const StyledBodyWrapper = styled.div`
&& {
  display: flex;
  flex: 1;
  flex-direction: column;
}
`;

export const StyledInputText = styled(InputText)`
&& {
  margin-bottom: 24px;
}
`;

export const StyledAnalysisWrapper = styled.div`
&& {
  margin-bottom: 24px;

  .tile {
    &:not(:first-child) {
      margin-left: 24px;
    }
  }
}
`;
